import { useEffect, useRef, useState } from "react";
import { Tooltip } from "./Tooltip";

export function Menu({show=true,children}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const headerDropdownRef = useRef(null);

  useEffect(() => {
    setMouseHandlers();
  }, []);

  const onItemClick = (e) => {
    e.stopPropagation();
    setIsDropdownOpen(false);
  }

  const setMouseHandlers = () => {
    const handleClickOutside = (event) => {
      if (headerDropdownRef.current && !headerDropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  };

  return (show ?
    <div ref={headerDropdownRef}>
      <div className="relative group">
        <button
          className="flex text-indigo-500 h-8 w-8 items-center justify-center rounded-full hover:bg-indigo-600 hover:text-white text-lg cursor-pointer"
          onClick={(e) => {e.stopPropagation(); setIsDropdownOpen(!isDropdownOpen); }}
        >
          <i className="fa-solid fa-ellipsis-v"></i>
        </button>
        <Tooltip text={"More Actions"}></Tooltip>
      </div>
      {isDropdownOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-sm z-20"
          onClick={onItemClick}
        >
          {children}
        </div>
      )}
    </div>
    :<></>
  );
}
